import React, { useEffect } from 'react';
import SubHeader from 'components/menu/SubHeader';
import './PortalPage.css';
import { useNavigate, useLocation } from "react-router-dom";
import { ConfirmationBox, IConfirmProps } from '../ui/ConfirmationBox';
import { ModalBox, IModalBoxProps } from '../ui/ModalBox';

export interface IPortalPageProps {
    module: string,
    page: string,
    loadingState: string,
    children: React.ReactNode,
    title?: string,
    route: string,
    icon?: any,
    confirmationProps?: IConfirmProps | null,
    modalProps?: IModalBoxProps | null
}

export const PortalPage = (props: IPortalPageProps) => {
    const Icon = props.icon;
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (props.route.length > 0 && props.route !== location.pathname) {
            navigate(props.route, { replace: true });
        }
    }, [props.route]);

    return (
        <div className={"portal-page " + props.module + " " + props.page + " " + props.loadingState}>
            {props.confirmationProps &&
                <ConfirmationBox {...props.confirmationProps} />
            }

            {props.modalProps &&
                <ModalBox {...props.modalProps} />
            }

            <div className="pp-back-drop-container">
                <div className="pp-back-drop">
                </div>
            </div>

            <div className="pp-content-container">
                <SubHeader />

                <div className="pp-content">

                    {props.title &&
                        <div className="pp-header">
                            {props.icon && <div className="icon"><Icon /></div>}
                            <div className="text">{props.title}</div>
                        </div>
                    }

                    {props.children}
                </div>

                <div className="footer-space">&nbsp;</div>
            </div>
        </div>
    );
};

export default PortalPage;